import React, { useState } from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import TextInput from "../../../../components/formfields/InputField";
import { getVideoPageData } from "./redux/selectors";
import { addContent } from "./redux/action";

function HeroSection() {
  const [heroEdit, setHeroEdit] = useState(false);
  const { content } = useSelector(getVideoPageData);
  const dispatch = useDispatch();

  const heroState = {
    name: content?.heading || "",
    description: content?.description || "",
  };

  const valieataionSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter title").max(20, "Title must be at most 20 characters long"),
  });

  const handleHeroSubmit = (values: any) => {
    const data = {
      content: JSON.stringify({ heading: values.name, description: values.description }),
    };
    dispatch(addContent(data));
    setHeroEdit(false);
  };

  return (
    <Formik enableReinitialize initialValues={heroState} onSubmit={handleHeroSubmit} validationSchema={valieataionSchema}>
      <Form>
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h6 className={`mb-0 ${heroEdit ? "editTitle" : ""}`}>Hero Section</h6>
            {heroEdit ? (
              <button type="submit" className="btn btn-primary">
                <i className="fa-regular fa-floppy-disk" /> Save
              </button>
            ) : (
              <span aria-hidden className="btn btn-green" onClick={() => setHeroEdit(true)}>
                Edit <i className="fa-regular fa-pen-to-square ms-2" />
              </span>
            )}
          </Card.Header>
          <Card.Body className="position-relative">
            <Row className="gy-3">
              <Col xs={12}>
                <BForm.Label className="form-label">Title</BForm.Label>
                <Field component={TextInput} name="name" />
              </Col>
              <Col xs={12}>
                <BForm.Label className="form-label">Description</BForm.Label>
                <Field component={TextInput} name="description" multiline />
              </Col>
            </Row>
            <div
              className={`position-absolute w-100 h-100 start-0 top-0 zIndex-2 ${heroEdit ? "d-none" : ""}`}
              style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
            />
          </Card.Body>
        </Card>
      </Form>
    </Formik>
  );
}

export default HeroSection;
